<template>
  <div id="app">
    <BlockUI v-show="isLoading" :message="getLoadingMessage">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getLoadingMessage']),
  },
};
</script>
<style>
body{
  font-family: Inter, Helvetica, Arial, sans-serif;
}
#app {
  font-family: Inter, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue